import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-177">
      <div className="max-w-4xl mx-auto" data-id="element-178">
        <div className="bg-bg-alt border border-primary/30 shadow-[0_0_30px_rgba(168,85,247,0.1)] rounded-3xl p-10 sm:p-16 text-center relative overflow-hidden" data-id="element-179">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-primary/5 blur-[50px] pointer-events-none" data-id="element-180"></div>

          <div className="w-24 h-24 mx-auto bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 rounded-full flex items-center justify-center mb-8 shadow-inner" data-id="element-181">
            <span className="text-5xl drop-shadow-[0_0_15px_rgba(168,85,247,0.5)]" data-id="element-182">
              🛡️
            </span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-black text-text-main mb-6 tracking-tight" data-id="element-183">
            WIN JE TIJD TERUG OF JE GELD TERUG
          </h2>

          <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-184">
            Wij zijn zo overtuigd van de kwaliteit van{' '}
            <span className="text-text-main font-bold" data-id="element-185">YOGA KLAAR</span>, dat we
            je een{' '}
            <span className="text-primary font-bold" data-id="element-186">
              30-dagen-niet-goed-geld-terug-garantie
            </span>{' '}
            bieden. Als je niet voelt dat je werk als docent makkelijker is
            geworden en je lessen dieper zijn geworden, storten we{' '}
            <span className="text-text-main font-bold" data-id="element-187">100% van je geld</span>{' '}
            terug. Zonder vragen.
          </p>
        </div>
      </div>
    </section>;
}